module.exports = __webpack_public_path__ + "img/KinokoTable48.0b962cb6.jpg";